var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLogout = function SvgIconLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 10.506h10m0 0-2 2m2-2-2-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M14 6.506v-1a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h5a4 4 0 0 0 4-4v-1"
  })));
};
export { SvgIconLogout as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTAuNTA1OUwxOCAxMC41MDU5TTE4IDEwLjUwNTlMMTYgMTIuNTA1OU0xOCAxMC41MDU5TDE2IDguNTA1ODYiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0IDYuNTA1ODZWNS41MDU4NkMxNCAzLjI5NjcyIDEyLjIwOTEgMS41MDU4NiAxMCAxLjUwNTg2SDVDMi43OTA4NiAxLjUwNTg2IDEgMy4yOTY3MiAxIDUuNTA1ODZWMTUuNTA1OUMxIDE3LjcxNSAyLjc5MDg2IDE5LjUwNTkgNSAxOS41MDU5SDEwQzEyLjIwOTEgMTkuNTA1OSAxNCAxNy43MTUgMTQgMTUuNTA1OVYxNC41MDU5IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";